<div class="sox-services service-pattern wow fadeInUp text-left purple-hover" data-wow-delay="0.4s">
    <div class="sox-icon">
        <h5 class="text-hover">Competitive Salary</h5>
        <i aria-hidden="true" class="flaticon flaticon-investment"></i>
    </div>
</div>